import {SUPPORTS_SYMBOL} from "./constructor";

export const SUPPORTS_SYMBOL_FOR = SUPPORTS_SYMBOL && "for" in Symbol;
